export function isServer() {
    return typeof window === 'undefined';
}

export function capitalize(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function removeHtmlTags(html: string) {
    return html.replace(/(<([^>]+)>)/gi, '');
}
